import { __commonJSMin as e } from "../../../../../../../_virtual/_rolldown/runtime.js";
//#region ../../node_modules/.pnpm/@intercom+intermoji@2.0.3/node_modules/@intercom/intermoji/lib/unique.js
var t = /* @__PURE__ */ e(((e, t) => {
	t.exports = function(e) {
		return e.filter(function(t, n) {
			return e.indexOf(t) === n;
		});
	};
}));
//#endregion
export default t();
export { t as require_unique };
